import React from 'react';

const Empty = ({ text }: { text?: string }) => <span className="gray">{text || '---'}</span>;

export default Empty;
